// @flow
// FlyerDetail Container

import type { Flyer, School } from 'types/FlyerTypes'

import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as R from 'ramda'
import qs from 'qs'

import { fetchOneDistrict } from 'redux/districts/actions'
import { fetchOneSchool } from 'redux/schools/actions'
import {
  fetchOneDistrictFlyer,
  fetchOneSchoolFlyer
} from 'redux/flyers/actions'
import FlyerDetail from './FlyerDetail'
import { setActiveFlyerId } from './redux'
import { redirectToNewParentApp } from '../../../../shared/utils/redirectToNewParentApp'

type OwnProps = {
  match: {
    params: { resource: string, flyerId: string, resourceId: string }
  }
}

type ReduxStateProps = {|
  flyer: ?Flyer, // nullable?
  resource: string,
  resourceId: string,
  flyerId: string,
  districtId: string,
  schools: ?Array<School>, // nullable?
  flyerIsLoading: boolean,
  resourceName: string,
  coBrandingUrl: string,
  coBrandingAlt: string,
  coBrandingLogoLink: string
|}

type ReduxDispatchProps = {|
  // !FIXME - Medium - Create action types instead of any. Shame on Justin.
  +fetchOneSchoolFlyer: (schoolId: string, flyerId: string) => any,
  +fetchOneDistrictFlyer: (districtId: string, flyerId: string) => any,
  +fetchOneDistrict: (districtId: string) => any,
  +fetchOneSchool: (schoolId: string) => any,
  +setActiveFlyerId: (flyerId: string) => void
|}

type Props = {
  ...OwnProps,
  ...ReduxStateProps,
  ...ReduxDispatchProps
}

class FlyerDetailContainer extends PureComponent<Props> {
  componentDidMount() {
    const { resource, resourceId, flyerId } = this.props
    this.props.setActiveFlyerId(flyerId)
    if (resource === 'schools') {
      this.props.fetchOneSchool(resourceId)
      this.props.fetchOneSchoolFlyer(resourceId, flyerId)
    } else if (resource === 'districts') {
      this.props.fetchOneDistrict(resourceId)
      this.props.fetchOneDistrictFlyer(resourceId, flyerId)
    }
  }

  componentDidUpdate(prevProps) {

    if (this.props.districtId !== prevProps.districtId) {
      const { resource, resourceId, districtId, flyerId } = this.props
      redirectToNewParentApp({
        resource,
        resourceId,
        districtId,
        flyerId,
      })
    }
  }



  render() {
    return <FlyerDetail {...this.props} />
  }
}

const getQueryParamsFromQueryString = queryString =>
  qs.parse(queryString, { ignoreQueryPrefix: true })

// !FIXME state should be typed to match combined reducers
const mapStateToProps = (state, props: OwnProps) => {
  // !FIXME pathOr expects a generic NestedObject type
  // $FlowFixMe
  const resource = R.pathOr(null, ['match', 'params', 'resource'], props)
  // $FlowFixMe
  const resourceId = R.pathOr(null, ['match', 'params', 'resourceId'], props)
  // $FlowFixMe
  const flyerId = R.pathOr(null, ['match', 'params', 'flyerId'], props)

  const flyer: ?Flyer = R.pathOr(null, ['flyers', flyerId], state)
  const schoolIds = flyer ? flyer.schools : []
  const schools = schoolIds.map(id => state.schools[id])
  const district = state.districts.district

  let resourceName = ''
  if (resource === 'districts') {
    resourceName = district ? district.name : ''

    // Override with staff group name if needed
    // Corresponding logic in: src/screens/Flyers/screens/FlyerGrid/index.js
    const queryParams = getQueryParamsFromQueryString(window.location.search)
    if (['district', 'school'].includes(queryParams.staff)) {
      resourceName = `Staff of ${resourceName}`
    }
  } else if (resource === 'schools') {
    const school = R.find(R.propEq('school_id', resourceId))(schools || [])
    resourceName = school && school.name
  }

  const coBrandingUrl = district.branding.logo_url
  const coBrandingAlt = district.branding.logo_alt
  const coBrandingLogoLink = district.branding.logo_link_url

  return {
    flyer,
    resource,
    resourceId,
    flyerId,
    schools,
    flyerIsLoading: state.flyers.isLoading,
    districtId: district.district_id,
    resourceName,
    coBrandingUrl,
    coBrandingAlt,
    coBrandingLogoLink
  }
}

const mapDispatchToProps = dispatch => ({
  fetchOneSchoolFlyer: (schoolId, flyerId) =>
    dispatch(fetchOneSchoolFlyer(schoolId, flyerId)),
  fetchOneDistrictFlyer: (districtId, flyerId) =>
    dispatch(fetchOneDistrictFlyer(districtId, flyerId)),
  fetchOneDistrict: districtId => dispatch(fetchOneDistrict(districtId)),
  fetchOneSchool: schoolId => dispatch(fetchOneSchool(schoolId)),
  setActiveFlyerId: flyerId => dispatch(setActiveFlyerId(flyerId))
})

const VisibleFlyersDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(FlyerDetailContainer)

export default withRouter(VisibleFlyersDetail)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/index.js